exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-border[data-v-7eac9f20]{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid #f9834e;border-right-color:transparent;border-radius:50%;-webkit-animation:spinner-border-data-v-7eac9f20 .75s linear infinite;animation:spinner-border-data-v-7eac9f20 .75s linear infinite;position:absolute;top:8px;right:8px}.input-container[data-v-7eac9f20]{position:relative}@-webkit-keyframes spinner-border-data-v-7eac9f20{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-border-data-v-7eac9f20{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eac9f20","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/admin-panel/components/admin/orders/userAutocomplete.vue
// module id = dOiq
// module chunks = 0